export enum BaseEntityActions {
  DefaultTaskLoad = '[Default] Task LOAD REQUESTED',
  DefaultTaskLoadSuccess = '[Default] Task LOAD SUCCESS',
  DefaultLoad = '[Default] LOAD REQUESTED',
  DefaultLoadSuccess = '[Default] LOAD SUCCESS',
  DefaultCreate = '[Default] CREATE REQUESTED',
  DefaultCreateSuccess = '[Default] CREATE SUCCESS',
  DefaultUpdate = '[Default]  UPDATE REQUESTED',
  DefaultUpdateSuccess = '[Default] UPDATE SUCCESS',
  DefaultRemove = '[Default] REMOVE REQUESTED',
  DefaultRemoveSuccess = '[Default] REMOVE SUCCESS',
  DefaultError = '[Default] Error'

}
